import Link from 'next/link'
import { className } from '@/components/common/styles'
import Panel from '@/components/common/Panel'

interface Props {
  className?: string
}

const PlanDetails = (props: Props) => {
  return (
    <div className={`p-4 ${props.className}`}>
      <Panel title="Plan details">
        <div className="grid grid-cols-2 gap-x-8">
          <div className="col-span-2 text-lg">
            <h2>Status</h2>
          </div>
          <div className="col-span-2 text-sm text-gray-600 dark:text-gray-400 pb-2">
            Plan is active since 2018-10-06.
          </div>
          <div className="col-span-2 pb-6">
            <button
              className={`${className} float-start`}
              type="submit"
              onClick={() => console.log('click button')}
            >
              Pause plan
            </button>
          </div>
          <div className="col-span-2 pb-4">
            <Link href="#!">
              <div className="text-blue-600 dark:text-blue-400 hover:underline decoration-2">
                Read more about pausing your plan
              </div>
            </Link>
          </div>
          <hr className="col-span-2 border border-dashed my-4" />
          <div className="col-span-2 text-lg">
            <h2>Trial</h2>
          </div>
          <div className="col-span-2 text-sm text-gray-600 dark:text-gray-400 pb-2">
            Trial ends on 2018-11-16 (14 days remaining).
          </div>
          <div className="col-span-2 pb-4">
            <Link href="#!">
              <div className="text-blue-600 dark:text-blue-400 hover:underline decoration-2">
                Goto Billing and add a payment method
              </div>
            </Link>
          </div>
        </div>
      </Panel>
    </div>
  )
}

export default PlanDetails
